@if(componentModel){
    <div class="relative bg-card min-w-80 text-normal h-72 w-full overflow-hidden rounded-lg shadow hover:shadow-lg transition-shadow duration-300"
       [ngClass]="{
        'hover:bg-card-hover': componentModel?.link?.value
    }">
        <div class="p-{{componentModel.spacing.value}} sm:flex text-normal">
            <img loading="lazy"  [src]="componentModel?.image?.value" class="w-full h-full object-cover" [alt]="componentModel.title.value">
            <div class="absolute bottom-0 w-full bg-gradient-to-t from-black via-black/60 to-transparent text-white p-4">
                <div class="flex justify-between items-end">
                    <div>
                        <h3 class="text-xl font-bold">{{componentModel.title.value}}</h3>
                        <p class="text-sm">{{componentModel.description.value}}</p>
                        <p class="text-xs">{{componentModel.metaData.value}}</p>
                    </div>
                        <a
                                [attr.href]="componentModel?.link?.value || null"
                                class="mt-3 px-4 py-2 rounded bg-primary hover:bg-primary-hover focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-button-primary-outline text-sm font-medium"
                        >
                            {{'registration' | translate}}
                        </a>

                </div>


            </div>
        </div>
    </div>
}

